<template>
	<div style="background-color: #f3f3f3; padding-left: 3vh; padding-top: 3vh;">
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>弹出广告>新建弹框</div>
		<div class="newADcontent">
			<!-- 			<div class="adExamples">
				<img src="../../../assets/phoneshili.png" />
			</div> -->
			<div class="adContent">
				<div class="title">
					<div class="blue"></div>
					<div style="flex: 1;">弹窗广告设置</div>
				</div>
				<el-form ref="form" :model="adExamplesList" label-width="150px" label-position="left">
					<el-form-item label="广告名称">
						<el-input v-model="adExamplesList.name" style="width: 300px;" size="small"
							placeholder=" 输入弹窗广告名称，不能超过12个字" maxlength="12" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="广告样式">
						<upload v-model="adExamplesList.style"  class="el-tabs-pane-upload"  ref="sss"
							style="width: 300px" />
						<p style="font-size: 12px;color: #999999">点击上传图片，建议尺寸650*650px，jpg\png格式，图片小于1M</p>
					</el-form-item>
					<el-form-item label="跳转方式">
						<el-select style="width: 150px;" size="small" v-model="adExamplesList.route">
							<el-option v-for="item in adExamplesList.routeList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="跳转地址">
						<el-input type="text" v-model="adExamplesList.jumpUrl" size="small" style="width: 400px;"
							placeholder="https://...或/page/..."></el-input>
					</el-form-item>
					<el-form-item label="投放时间">
						<el-date-picker size="small" v-model="adExamplesList.time" type="datetimerange"
							value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="投放位置">
						<el-select style="width: 150px;" size="small" v-model="adExamplesList.addr">
							<el-option v-for="item in addrList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择用户标签">
						<el-checkbox-group v-model="adExamplesList.labels">
							<el-checkbox :label="i.id" v-for="i in labeldata">{{i.labelName}}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="曾消费过的门店">
						<el-select v-model="adExamplesList.store" filterable multiple placeholder="选择门店"
							@change="checkStore">
							<el-option v-for="item in storelist" :key="item.id" :label="item.title" :value="item.id"
								:disabled="adExamplesList.store[0]==0 && item.id !=0 ">
							</el-option>
						</el-select>
						<!-- 						<el-radio-group v-model="adExamplesList.storetype">
							<el-radio :label="s.label" v-for="s in storeType">{{s.label}}</el-radio>
						</el-radio-group>
						<el-checkbox-group v-model="adExamplesList.store" v-if="adExamplesList.store">
							<el-checkbox :label="i.id" v-for="i in stores">{{i.title}}</el-checkbox>
						</el-checkbox-group> -->
					</el-form-item>
					<!-- 				<el-form-item label="优惠券">
					<el-button @click="dialog_quan=true" type="button" style="color: #565656;"><i class="el-icon-plus"></i>选择优惠券</el-button>
				</el-form-item> -->
					<el-form-item>
						<router-link to="/marketingAd">
							<el-button>取消</el-button>
						</router-link>
						<el-button @click="saveAdvertisement()" type="primary" style="margin-left: 20px;">保存</el-button>
					</el-form-item>
				</el-form>
				<el-dialog :visible.sync="dialog_quan" width="60%">
					<div class="title" style="margin-top:-10px;">
						<div class="blue"></div>
						<div style="flex: 1;">选择优惠券</div>
						<span style="margin-left: 35%;">
							<el-button @click="dialog_quan = false">取 消</el-button>
							<el-button type="primary" @click="dialog_quan = false">确 定</el-button>
						</span>
					</div>
					<div>
						<el-table :cell-style="{'text-align':'center'}"
							:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
							:data="couponList" tooltip-effect="dark" style="width: 100%">
							<el-table-column label="券ID">
								<template scope="scope">
									<el-radio :label="scope.row.id" v-model="adExamplesList.couponRadio"></el-radio>
								</template>
							</el-table-column>
							<el-table-column align="center" prop="title" label="名称"></el-table-column>
							<el-table-column prop="couponType" label="类型"></el-table-column>
							<el-table-column prop="storeNames" label="适用范围"></el-table-column>
							<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
							<el-table-column prop="getNumScaleTotalNum" label="已领取/优惠券总量"></el-table-column>
							<el-table-column prop="useNum" label="已使用"></el-table-column>
						</el-table>
						<div class="pagescg">
							<el-pagination @size-change="handleSizeChange02" @current-change="handleCurrentChange02"
								:current-page="query.page" :page-sizes="[10, 20, 30, 50]" :page-size="10"
								layout="sizes, prev, pager, next, jumper" :total="query.total">
							</el-pagination>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	import upload from "../../compents/upload/upload"
	export default {
		components: {
			upload
		},
		data() {
			return {
				query: {
					page: 1,
					size: 10,
					total: 100,
				},
				dialog_quan: false,
				couponList: [],
				imgurl: "",
				storelist: [{
					title: "所有门店",
					id: 0,
				}],
				/* 				storeType:[{
										label:"所有门店",
										value:"0"
									},
									{
										label:"部分门店",
										value:"1"
									}
								], */
				labeldata: {},
				addrList: [{
					value: "0",
					label: "首页"
				}, {
					value: "1",
					label: "订单页"
				}, {
					value: "2",
					label: "我的"
				}, {
					value: "3",
					label: "会员页"
				}, {
					value: "4",
					label: "活动页"
				}, ],
				adExamplesList: {
					name: undefined,
					style: "",
					State: undefined,
					img: undefined,
					jumpUrl: undefined,
					label: '',
					labels: [],
					store: [0],
					route: [],
					routeList: [{
						value: "0",
						label: "跳转路径"
					}, {
						value: "1",
						label: "小程序内部页面"
					}],
					time: [],
					addr: [],
					crowd: "",
					countState: '',
					count: "",
					couponRadio: [],
					countList: [{
						value: "1",
						label: "1"
					}, {
						value: "2",
						label: "2"
					}]
				},
			}
		},
		methods: {
			checkStore(val) {
				if (val.indexOf(0) > -1) this.adExamplesList.store = [0]
			},
			getUserLabel() {
				this.$http.post("dvertisement/selectLabel").then(function(res) {
					this.labeldata = res.body.data;
					if (this.$route.query.id) {
						var a = {
							id: this.$route.query.id,
							pageNum: 1,
							pageSize: 1
						}
						this.$http.post("dvertisement/findDAdvertisement", JSON.stringify(a)).then(function(res) {
							if (res.body.code == 200) {
								let a = JSON.parse(JSON.stringify(res.body.data[0]));
								this.adExamplesList.name = a.name;
								this.adExamplesList.jumpUrl = a.jumpUrl;
								this.adExamplesList.route = a.type + ""; //跳转路径
								this.adExamplesList.style = a.style;
								this.adExamplesList.label = a.label;
								this.adExamplesList.addr = a.popPosition;
								this.adExamplesList.store = a.storeId.split(",").map(ele => {
									return Number(ele)
								});
								this.addrList.map(l => {
									if (this.adExamplesList.addr.indexOf(l.label) != -1) this
										.addrList.push(l.id);
								})
								let tempTime = new Array();
								tempTime.push(a.startTime);
								tempTime.push(a.endTime);
								this.adExamplesList.time = tempTime;
								this.labeldata.map(l => {
									if (this.adExamplesList.label.indexOf(l.labelName) != -1) this
										.adExamplesList.labels.push(l.id);
								})
							}
						})
					}
					this.$http.get("store/list").then(function(res) {
						this.storelist.push(...res.body.data);
					})
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			saveAdvertisement() {
				var a = {
					id: this.$route.query.id,
					name: this.adExamplesList.name,
					style: this.adExamplesList.style,
					type: this.adExamplesList.route,
					jumpUrl: this.adExamplesList.jumpUrl,
					startTime: this.adExamplesList.time[0],
					endTime: this.adExamplesList.time[1],
					popPosition: this.adExamplesList.addr,
					label: this.adExamplesList.labels.toString(),
					storeId: this.adExamplesList.store.toString(),
				}
				if (!a.name) {
					return this.$message.error("请输入广告名称");
				}
				if (!a.jumpUrl) {
					return this.$message.error("请填写跳转地址");
				}
				if (!a.startTime) {
					console.log("========" + a.startTime);
					return this.$message.error("请选择投放时间");
				}
				if (!a.label) {
					return this.$message.error("请选择投放人群");
				}
				if (this.$route.query.id) {
					this.$http.post("dvertisement/editDAdvertisement", JSON.stringify(a)).then(function(res) {
						if (res.body.code == 200) {
							this.$router.push("/marketingAd");
							this.$message.success("保存成功");
						}
					})
				} else {
					this.$http.post("dvertisement/saveDAdvertisement", JSON.stringify(a)).then(function(res) {
						if (res.body.code == 200) {
							this.$router.push("/marketingAd");
							this.$message.success("保存成功");
						}
					})
				}
			},
			getCoupon() {
				var q = "?pageNum=" + this.query.page + "&pageSize=" + this.query.size;
				this.$http.get("dvertisement/selectCoupon" + q).then(function(res) {
					this.couponList = res.body.data.data;
				}, function(err) {

				})
			},
			handleSizeChange02(val) {
				this.query.size = val;
				this.getCoupon();
			},
			handleCurrentChange02(val) {
				this.query.page = val
				this.getCoupon();
			},
		},
		mounted() {
			this.getUserLabel();
			this.getCoupon();
		},
	}
</script>

<style lang="less" scoped>
	p {
		margin: 0;
		padding: 0;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.newADcontent {
		display: flex;

		// & > div{
		// 	display: inline-block;
		// }
		.adContent {
			flex: 2;
		}

		.adExamples {
			flex: 1;
			padding: 0 30px;

			img {
				width: 300px;
				height: auto;
			}
		}
	}
</style>